import {Flow} from "../../flows/Flow.js";
import {CalculateShippingPrice} from "../../../../client/state/misc/ShippingPrice.js";
import {Messages} from "../../../Messages.js";
import {BasePanelPage} from "../../PanelPage";
import {BlinkButton} from "../../../../core/ui/Button.jsx";


export class ShopReviewOrderPanel extends BasePanelPage {
    render() {
        const {styleSheet} = this;
        const product = Flow.productList.selectedValue;
        const address = Flow.address.selectedValue;

        return [
            <div>{product.name}</div>,
            address && <div>{address} - {CalculateShippingPrice(address, product.getShippingPrices())}</div>,

            <BlinkButton
                label={Messages.continueToPayment}
                onClick={() => Flow.purchaseReview.updateAndResolve()}
                className={styleSheet.actionButton}
            />,

            Flow.renderBackButton(),
        ]
    }
}
